import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonTable, { ITableColumn } from '@/components/common/CommonTable';
import FilterComponent from '@/components/common/FilterComponent';
import MainHeading from '@/components/common/MainHeading';
import EditIcon from '@/components/Icons/EditIcon';
import CardLayout from '@/components/Layout/CardLayout';
import Layout from '@/components/Layout/Layout';
import useFilter from '@/hooks/useFilter';
import { ISiteSalaryHeadResponse } from '@/interfaces/salary.model';
import { RootState } from '@/redux/store';
import {
  getFilterUrl,
  orderByList,
  showToastNotification,
} from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
interface ITableData {
  id: string;
  index: number;
  name: string;
  companyName: string;
}
interface IPageStates {
  currentPage: number;
  pageSize: number;
  count: number;
  totalPages: number;
  tableLoader: boolean;
  SiteSalaryHeadData: ITableData[];
  searchQuery: string;
  downloadLoading: boolean;
}
const SiteSalaryHead = () => {
  const tableHeading: ITableColumn<ITableData>[] = [
    { value: 'index', label: '#' },
    { value: 'name', label: 'Site Name' },
    { value: 'companyName', label: 'Company' },
  ];
  const tableView = useSelector((state: RootState) => state?.user?.tableView);
  const navigate = useNavigate();
  const filterDetails = useSelector(
    (state: RootState) => state?.user?.filtersStates,
  );
  const [pageStates, setPageStates] = useState<IPageStates>({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    SiteSalaryHeadData: [],
    searchQuery: '',
    downloadLoading: false,
  });
  const ActionData = [
    {
      label: 'Edit',
      className: 'btn btn-link',
      icon: <EditIcon />,
      title: 'edit',
      clickHandler: (data: ITableData) =>
        navigate(RoutesLink.addSiteSalaryHead, { state: data }),
    },
  ];
  useEffect(() => {
    getSiteSalaryHead();
  }, [pageStates.searchQuery, filterDetails.orderBy]);
  const getSiteSalaryHead = async () => {
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
    }));
    try {
      const filter = {
        search: pageStates.searchQuery,
        orderBy: filterDetails?.orderBy,
        pageNumber: pageStates?.currentPage,
      };
      const response: ISiteSalaryHeadResponse = await callApi(
        API_URL + API_ENDPOINT.getSiteSalaryHead + '?' + getFilterUrl(filter),
        { method: 'GET' },
      );
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));

      if (response?.status) {
        const newData: ITableData[] = response?.data?.siteSalaryHead?.map(
          (item, index) => ({
            ...item,
            index: index,
            companyName: item?.Company?.name,
            name: item?.name,
          }),
        );
        setPageStates((prevStates) => ({
          ...prevStates,
          SiteSalaryHeadData: newData,
          count: response?.data?.pageInfo?.total ?? 0,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
    }
  };

  const {
    handleSearchChange,
    orderByHandler,
    pageChangeHandler,
    handleChangePageSize,
  } = useFilter(pageStates, setPageStates);
  return (
    <Layout>
      <MainHeading title={'Site Salary Head'} />
      <CardLayout isGrid={tableView === 'grid'}>
        <FilterComponent
          handleSearch={handleSearchChange}
          searchPlaceHolder={'Search By Site Name'}
          orderByHandler={orderByHandler}
          orderByList={orderByList}
          isGrid={false}
        />
        <CommonTable<ITableData>
          tableHeading={tableHeading}
          tableData={pageStates?.SiteSalaryHeadData}
          ActionData={ActionData}
          currentPage={pageStates?.currentPage}
          pageChangeHandler={pageChangeHandler}
          isLoading={pageStates?.tableLoader}
          totalPages={pageStates?.totalPages}
          count={pageStates?.count}
          handleChangePageSize={handleChangePageSize}
          pageSize={pageStates.pageSize}
        />
      </CardLayout>
    </Layout>
  );
};
export default SiteSalaryHead;
